import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {HttpService} from "../service/http-service";
import {API} from "../config/api-config";
declare var alertify:any;
@Component({
  templateUrl:'./fanstvPlan.html'
})

export class FanstvPlan implements OnInit{

  constructor(
    private router:Router,
    private http:HttpService
  ){}

  private data:any=[];

  private imagePath:string='';

  ngOnInit(): void {
    this.getData();
  }



  private getData(){
    this.http.getData(API.contractPlan).then(res=>{
      this.data=res.data;

    });
  }

  private editFanstvPlan(code:any){
    this.router.navigate(['index/fanstvPlan',code]);
  }

}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/film/fanstvPlan.component.ts